<template>
    <div class="customer-dashboard">
        <template v-if="checkAppCode('sas')">
            <div class="p-4">
                <iframe class="responsive-iframe" src="https://app.powerbi.com/view?r=eyJrIjoiNjM4ZTIxZTYtZjVlOS00NmY0LTllODktNzg3MzM0NTliODI4IiwidCI6IjQxOTgwZDg5LWY2ZDUtNDdmNy04MmI0LWM3ZjYwMzliZDBlYyIsImMiOjEwfQ%3D%3D" frameborder="0" allowFullScreen="true" style="min-height:2100px; width:100%; overflow-y: hidden;" scrolling="no"></iframe>
            </div>
        </template>
    </div>
</template>
<script>
import {
  notifyFunctionMixin,
  helperFunctionMixin,
  axios,
  services,
  getHeader
} from '@/assets/js/httpImports.js'
import { useAuthStore } from '@/stores/authStore'
import { mapActions, mapState } from 'pinia'

export default {
    mixins:[helperFunctionMixin],
    computed:{
        ...mapState(useAuthStore, ['auth_user'])
    },
}
</script>